// extracted by mini-css-extract-plugin
module.exports = {"deliveryContainer":"DeliveryItems_deliveryContainer__mByCw","deliveryButtonItem":"DeliveryItems_deliveryButtonItem__VDAvm","isToComplete":"DeliveryItems_isToComplete__QydDw"};